
















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class KEditableCell extends Vue {
  @Prop() text!: string;
  value: string = this.text;
  editable: boolean = false;

  handleChange(e: any) {
    const value = e.target.value;
    this.value = value;
  }
  check() {
    this.editable = false;
    this.$emit('change', this.value);
  }
  edit() {
    this.editable = true;
  }
}

